import A1C from 'assets/DashboardBanner/A1C.png';
import Bill from 'assets/DashboardBanner/Bill.svg';
import BreastCancer from 'assets/DashboardBanner/BreastCancer.png';
import Cancer from 'assets/DashboardBanner/Cancer.png';
import Coagulation from 'assets/DashboardBanner/Coagulation.png';
import Covid from 'assets/DashboardBanner/Covid.png';
import FluShot from 'assets/DashboardBanner/FluShot.png';
import HPV from 'assets/DashboardBanner/HPV.png';
import Detective from 'assets/detective.png';
import DogRunning from 'assets/DashboardBanner/DogRunning.gif';
import AvatarMale from 'assets/DashboardBanner/AvatarMale.svg';
import AvatarsFemale from 'assets/DashboardBanner/AvatarsFemale.svg';
import AvatarsMale from 'assets/DashboardBanner/AvatarsMale.svg';
import Evisit from 'assets/DashboardBanner/Evisit.svg';
import Goals from 'assets/DashboardBanner/Goals.svg';
import MyHealth from 'assets/DashboardBanner/MyHealth.svg';
import Notifications from 'assets/DashboardBanner/Notifications.svg';

export enum DBColors {
  orange = '#FFB768',
  lightBlue = '#B6EDF6',
  lightGreen = '#DBF3D2',
  dimBlue = '#AED3EF',
  dimGreen = '#93E4D8',
  pink = '#FBC0D1',
  red = '#FFA689',
  white = '#F2F5F9',
  purple = '#DDD0FC',
  blue = '#36B7E8',
  yellow = '#FAE780',
  grey = '#E4E4E4'
}

export const DashboardCards = {
  mammogram: {
    imageName: BreastCancer,
    background: DBColors.pink
  },
  fluShot: {
    imageName: FluShot,
    background: DBColors.orange
  },
  cervicalCancer: {
    imageName: Cancer,
    background: DBColors.dimGreen
  },
  diabetes: {
    imageName: A1C,
    background: DBColors.lightGreen
  },
  hpv: {
    imageName: HPV,
    background: DBColors.dimBlue
  },
  antiCoagulation: {
    imageName: Coagulation,
    background: DBColors.grey
  },
  covid: {
    imageName: Covid,
    background: DBColors.blue
  },
  notification: {
    imageName: Notifications,
    background: DBColors.orange
  },
  avatarsCardFemale: {
    imageName: AvatarsFemale,
    background: DBColors.purple
  },
  avatarsCardMale: {
    imageName: AvatarsMale,
    background: DBColors.dimGreen
  },
  evisitInProgress: {
    imageName: Evisit,
    background: DBColors.dimGreen
  },
  evisitAvailable: {
    imageName: Evisit,
    background: DBColors.lightGreen
  },
  goals: {
    imageName: Goals,
    background: DBColors.dimBlue
  },
  rta: {
    imageName: Bill,
    background: DBColors.blue
  },
  changesToPeople: {
    imageName: AvatarMale,
    background: DBColors.yellow
  },
  welcome: {
    imageName: MyHealth,
    background: DBColors.grey
  },
  error: {
    imageName: Detective,
    background: DBColors.grey
  },
  loading: {
    imageName: DogRunning,
    background: DBColors.grey
  }
};
